
import { Component, ChangeDetectionStrategy, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface ExportSelection {
  type: 'ALL' | 'MONTH' | 'CUSTOM';
  startDate?: string;
  endDate?: string;
}

@Component({
  selector: 'app-export-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './export-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportModalComponent {
  isOpen = input.required<boolean>();
  isProcessing = input<boolean>(false);
  
  closeModal = output<void>();
  confirmExport = output<ExportSelection>();

  exportType = signal<'ALL' | 'MONTH' | 'CUSTOM'>('ALL');
  customStart = signal<string>('');
  customEnd = signal<string>('');

  constructor() {
    // Set default custom dates to today
    const today = new Date().toISOString().split('T')[0];
    this.customStart.set(today);
    this.customEnd.set(today);
  }

  onTypeChange(type: 'ALL' | 'MONTH' | 'CUSTOM') {
    this.exportType.set(type);
  }

  onConfirm() {
    if (this.exportType() === 'CUSTOM') {
        if (!this.customStart() || !this.customEnd()) {
            return; // Validate inputs
        }
    }

    this.confirmExport.emit({
        type: this.exportType(),
        startDate: this.customStart(),
        endDate: this.customEnd()
    });
  }

  onClose() {
    this.closeModal.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget && !this.isProcessing()) {
      this.onClose();
    }
  }
}
